@if (fouten$ | async; as fouten) {
    @for (line of fouten.lines; track line.key) {
        <span class="downloads-fouten__line">{{ line.key | translate: line.params }}</span>
    }
}
